import { SortEvent } from "primeng/primeng";
import { debounceTime, map, distinctUntilChanged } from "rxjs/operators";
import { ModelState } from "../../../../helpers/enums";
import { SearchColumn } from "../../search-utils";
import { MappingItem } from "../../../../helpers/setting";
import { IServiceDataLoader } from "../../../../interfaces/utils.interface";
import { Page } from "../../../../helpers/response";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import { fromEvent } from "rxjs/internal/observable/fromEvent";

@Component({
  selector: "search-content",
  templateUrl: "./search-content.component.html"
})
export class SearchContentComponent
  implements OnInit, AfterViewInit, OnDestroy {
  readonly MODEL_STATE = ModelState;
  private _columns: SearchColumn[];
  private _bindings: MappingItem[] = [];
  private _activeColumn: SearchColumn;
  private _subscriptions: Subscription[] = [];

  sortField: string;
  placeholder: string;
  loading = false;

  @Input() searchTitle = "Busqueda";
  @Input() service: IServiceDataLoader<any>;
  @Input()
  set columns(value: SearchColumn[]) {
    this._columns = value;
    if (this._columns && this._columns.length > 0) {
      this.activeColumn = this._columns[0];
      this._columns
        .filter(item => item.MapPropertyName)
        .forEach(map => {
          this._bindings.push(
            new MappingItem(map.MapPropertyName, map.PropertyName)
          );
        });
    }
  }
  get columns(): SearchColumn[] {
    return this._columns;
  }
  @Input() value: any;
  @Input() host: string; //'modal | overlay'
  @Input() pgMaxSize = 4;
  @Input() pgBoundaryLinks = true;
  @Input() pgPreviousText = "&lsaquo;";
  @Input() pgNextText = "&rsaquo;";
  @Input() pgFirstText = "&laquo;";
  @Input() pgLastText = "&raquo;";
  @Input() pgShowTotalRows = true;
  @Input() method = "GetPage";
  @Input()
  get activeColumn(): SearchColumn {
    return this._activeColumn;
  }

  @Output() onClose = new EventEmitter();
  @Output() okAndNewChange = new EventEmitter<SearchColumn>();

  set activeColumn(value: SearchColumn) {
    this._activeColumn = value;

    if (this._activeColumn) {
      this.okAndNewChange.emit(this._activeColumn);
      this.placeholder = `Buscar por ${value.DisplayName}`;

      if (this.sortField != this._activeColumn.PropertyName) {
        this.sortField = this._activeColumn.PropertyName;
      }
    }
  }
  @ViewChild("pSearch") searchInput: ElementRef;

  ngOnInit() {
    this.service.loadingOnGet = false;
    this.service.rowsPerPage.unshift(5);
    this.service.requestSetting.Page.Size = 5;

    this._subscriptions.push(
      this.service.loadEmitter.subscribe(args => {
        this.setLoading(false);
      })
    );
    if (!this.service.data || this.service.data.length == 0) {
      this.service.refresh();
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscr: Subscription) => {
      subscr.unsubscribe();
    });
  }

  ngAfterViewInit() {
    const event = fromEvent(this.searchInput.nativeElement, "keyup").pipe(
      map((i: any) => i.currentTarget.value),
      debounceTime(500),
      distinctUntilChanged()
    );
    this._subscriptions.push(
      event.subscribe(value => {
        this._activeColumn.Value = value;
        this.search();
      })
    );
  }

  select(model: any) {
    this._updateBinds(model);
    this.onClose.emit({
      commit: true,
      model: model
    });
    this.activeColumn.Value = undefined;
  }

  search() {
    this.setLoading(true);
    this.service.requestSetting.Filters = [];
    this.service.requestSetting.Filters.push(this._activeColumn.ToFilter());
    this.service.load(this.service.requestSetting);
  }

  cancel() {
    this.onClose.emit({
      commit: false,
      model: undefined
    });
  }

  onPaginate(page: Page) {
    this.service.requestSetting.Page = page;
    this.search();
    this.focus();
  }

  private _updateBinds(model: any) {
    if (this.value) {
      this._bindings.forEach(
        (bindings: MappingItem) =>
          (this.value[bindings.leftMember] = model[bindings.rightMember])
      );
    }
  }

  customSort(event: SortEvent) {
    if (this._activeColumn.PropertyName != event.field) {
      this.activeColumn = this._columns.find(
        col => col.PropertyName == event.field
      );
      this.activeColumn.Value = "";
      this.focus();
    }
  }

  onRowClick(event) {
    event.stopPropagation();
    this.focus();
  }

  focus() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
      this.searchInput.nativeElement.select();
    });
  }

  setLoading(value: boolean) {
    Promise.resolve(null).then(() => {
      this.loading = value;
    });
  }
}
